import { queryParams, type RouteQueryOptions, type RouteDefinition, applyUrlDefaults } from './../../../../../wayfinder'
/**
* @see \App\Http\Controllers\Item\UnlinkItemOptionToEnaosController::__invoke
* @see app/Http/Controllers/Item/UnlinkItemOptionToEnaosController.php
* @route '/api/item/{item}/enaos/{enaos_item}/unlink'
*/
const UnlinkItemOptionToEnaosController = (args: { item: string | { id: string }, enaos_item: string | number | { id: string | number } } | [item: string | { id: string }, enaos_item: string | number | { id: string | number } ], options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: UnlinkItemOptionToEnaosController.url(args, options),
    method: 'post',
})

UnlinkItemOptionToEnaosController.definition = {
    methods: ["post"],
    url: '/api/item/{item}/enaos/{enaos_item}/unlink',
} satisfies RouteDefinition<["post"]>

/**
* @see \App\Http\Controllers\Item\UnlinkItemOptionToEnaosController::__invoke
* @see app/Http/Controllers/Item/UnlinkItemOptionToEnaosController.php
* @route '/api/item/{item}/enaos/{enaos_item}/unlink'
*/
UnlinkItemOptionToEnaosController.url = (args: { item: string | { id: string }, enaos_item: string | number | { id: string | number } } | [item: string | { id: string }, enaos_item: string | number | { id: string | number } ], options?: RouteQueryOptions) => {
    if (Array.isArray(args)) {
        args = {
            item: args[0],
            enaos_item: args[1],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        item: typeof args.item === 'object'
        ? args.item.id
        : args.item,
        enaos_item: typeof args.enaos_item === 'object'
        ? args.enaos_item.id
        : args.enaos_item,
    }

    return UnlinkItemOptionToEnaosController.definition.url
            .replace('{item}', parsedArgs.item.toString())
            .replace('{enaos_item}', parsedArgs.enaos_item.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\Item\UnlinkItemOptionToEnaosController::__invoke
* @see app/Http/Controllers/Item/UnlinkItemOptionToEnaosController.php
* @route '/api/item/{item}/enaos/{enaos_item}/unlink'
*/
UnlinkItemOptionToEnaosController.post = (args: { item: string | { id: string }, enaos_item: string | number | { id: string | number } } | [item: string | { id: string }, enaos_item: string | number | { id: string | number } ], options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: UnlinkItemOptionToEnaosController.url(args, options),
    method: 'post',
})

export default UnlinkItemOptionToEnaosController